<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <HomeBanner />
    <HomeIbase v-if="item.secIbaseAtiva"  :titulo="item.secIbaseTitulo" :subtitulo="item.secIbaseSubtitulo" :conteudo="item.secIbaseConteudo" :imagem="item.secIbaseImagem" :solucao="item.secIbaseSolucao" />
    <HomeDemo v-if="item.secDemoAtiva" :titulo="item.secDemoTitulo" :subtitulo="item.secDemoSubtitulo" :conteudo="item.secDemoConteudo"/>
    <HomeSolucoes v-if="item.secSolucoesAtiva" :primeiroDestaque="item.secSolucoesPrimeiroDestaque" :segundoDestaque="item.secSolucoesSegundoDestaque" :terceiroDestaque="item.secSolucoesTerceiroDestaque" />
    <HomeServicos v-if="item.secServicosAtiva" :titulo="item.secServicosTitulo" :subtitulo="item.secServicosSubtitulo" />
    <HomeClientes v-if="item.secClientesAtiva" />
    <HomeSobreNos v-if="item.secSobreNosAtiva" :titulo="item.secSobreNosTitulo" :subtitulo="item.secSobreNosSubtitulo" :imagens="item.secSobreNosImagens"/>
    <HomeFunFact />
    <BannerContactos tipo="1" />
  </div>
</template>

<script>
import HomeBanner from '@/components/HomeBanner.vue';
import HomeIbase from '@/components/HomeIbase.vue';
import HomeDemo from '@/components/HomeDemo.vue';
import HomeSolucoes from '@/components/HomeSolucoes.vue';
import HomeServicos from '@/components/HomeServicos.vue';
import HomeClientes from '@/components/HomeClientes.vue';
import HomeSobreNos from '@/components/HomeSobreNos.vue';
import HomeFunFact from '@/components/HomeFunFact.vue';
import BannerContactos from '@/components/BannerContactos.vue';
export default {
  components: {
    HomeBanner,
    HomeIbase,
    HomeDemo,
    HomeSolucoes,
    HomeServicos,
    HomeClientes,
    HomeSobreNos,
    HomeFunFact,
    BannerContactos
  },
  data() {
    return {
      loaded: false,
      item: {}
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      setTimeout(() => {
        this.loaded = true;
      }, 400)
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'HomePagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
